import React from "react";
import { useNavigate } from "react-router-dom";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";

const HomeEnd = () => {
  const navigate = useNavigate();

  return (
    <section className="text-center px-6 py-12 space-y-10 font-belleza">
      {/* === BEIGE STRIP === */}
      <div className="bg-[#D4AF37]/45 py-6 px-4">
        <h3 className="text-[#14767E] text-2xl md:text-3xl tracking-wider uppercase font-sunday text-center">
          Let Aurah Leisure Curate Your Next Journey
        </h3>
      </div>

      {/* === CONTACT CTA BUTTON === */}
      <div className="text-center">
        <button
          onClick={() => navigate("/contact")}
          className="font-garet font-semibold text-[14.5px] border-[#D4AF37] border-2 text-[#D4AF37] py-1 px-3 rounded-sm hover:bg-[#D4AF37]/45 hover:text-[#14767E] hover:border-[#D4AF37]/45 transition"
        >
          CONTACT US
        </button>

        <div className="mt-7 space-y-1">
          <p className="text-sm text-gray-700 font-poppins">📞 +91 98198 75820</p>
          <p className="text-sm text-gray-700 font-poppins">✉️ holidays@aurahleisure.in</p>
        </div>
      </div>
      {/* === FOOTER DECORATION WITH DOTTED LINE AND CIRCLES === */}
      <div className="w-full mt-10 px-4">
        <div className="relative w-full h-28 bg-center bg-no-repeat bg-contain">
          {/* === SOCIAL ICONS === */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-8">
            <div className="flex gap-4 items-center justify-center mt-6">
              <a
                href="https://www.instagram.com/aurah.leisure"
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink-600 text-2xl hover:scale-110 transition-transform"
              >
                <FaInstagram />
              </a>

              <a
                href="https://wa.me/919819875820" // Replace with your business number
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-600 text-2xl hover:scale-110 transition-transform"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* === COPYRIGHT === */}
      <p className="text-sm mt-6">© 2025 Aurah Leisure Pvt. Ltd.</p>
    </section>
  );
};

export default HomeEnd;
